module.exports = __webpack_public_path__ + "static/images/alert-small.954502589d7c45ecdf535933a0c25209.svg";